export const paths = {
  authLogin: '/auth/login',
  login: '/login',
  app: '/app',
  submit: '/app/submit',
  overview: '/app/overview',
} as const;

export type Path = (typeof paths)[keyof typeof paths];
